import React from 'react';

/**
 * Where the customer's own subject came in ONE answer.
 *
 * An integer placing, deliberately bare: at answer grain the position is exactly the mention
 * sequence, so there is no mean to disclose and nothing to put behind a hover. The ordinal with a
 * float mean and its answer count is the visibility table's job, not this one's.
 *
 * ABSENT IS STATED, NOT FILLED. An answer that never positioned the target says so; `#0` would read
 * as a placing ahead of first, and a fallback ordinal would put the target in a sequence it never
 * entered.
 *
 * Both states are one line of fixed-size text inside the card, with no `min-h`, no `h-full` and no
 * flex growth, so nothing beside it is resized by whichever state renders.
 */
export function AnswerTargetPosition({ position }: { position?: number }) {
  return (
    <div className="rounded-xl bg-white p-4 ring-1 ring-inset ring-slate-200/80">
      <div className="font-eyebrow text-[0.625rem] font-medium uppercase tracking-[0.14em] text-slate-500 mb-1">Your position</div>
      {position === undefined ? (
        <div className="text-sm text-slate-500">Not positioned in this answer</div>
      ) : (
        <div className="text-base font-bold text-slate-900">#{position}</div>
      )}
    </div>
  );
}
